































import { Component, Vue } from 'vue-property-decorator';

import { bus } from '@/main'
const onClickaway = require('vue-clickaway');

@Component({
	directives: {
		onClickaway: onClickaway.directive
	}
})
export default class AppFooter extends Vue {
	shareMenuOpen: boolean = false

	reportExternalLink(location: 'tool' | 'social'): void {
		_paq.push(['trackEvent', 'userEvent', 'doSocialShare']);
	}

	created() {
		bus.$on('changeDirection', (direction: 'next' | 'previous') => {
			this.shareMenuOpen = false
		})
	}
}
